import { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';

import Heading from '@/components/common/Heading';

interface IAddressItemProps {
  icon: string;
  title: string;
  text?: string;
  contacts?: string;
  ariaLabel: string;
  address?: string[];
}

const AddressItem: FC<IAddressItemProps> = ({
  icon,
  title,
  text,
  contacts,
  ariaLabel,
  address,
}) => {
  return (
    <>
      <address className="flex items-baseline gap-2 not-italic">
        <Image
          className=" w-6 h-6 md:h-7 md::h-7"
          src={`/assets/icons/contactsAddress/${icon}`}
          width={100}
          height={100}
          alt={`${title}`}
        />
        <div>
          <Heading
            headingLevel="h3"
            className="font-medium mb-3 text-[1.25rem] md:text-[1.75rem]"
          >
            {title}
          </Heading>
          {address && (
            <div className="card-set [--card-gap:4px] ">
              {address.map((i, id) => (
                <p
                  key={id}
                  className="custom-p font-light text-sm md:text-base card-set-item  leading-[1.2rem]"
                >
                  {i}
                </p>
              ))}
            </div>
          )}
          {contacts && (
            <Link
              className="custom-p font-light  hover:text-[--accent-color] text-sm md:text-base leading-[1.2rem]"
              href={`${contacts}`}
              aria-label={ariaLabel}
            >
              {text}
            </Link>
          )}
        </div>
      </address>
    </>
  );
};

export default AddressItem;
